import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import { Router } from 'react-router-dom';
import { useLocation, Switch } from 'react-router-dom';
import Sidenav from '../../_components/layout/Sidenav';
import { history } from '../../_helpers';
import { setToast } from '../../store/ToastManagement';
import { dbUTCDatetimeToLocal, linkifyText, deLinkifyText } from '../../utils';
import {
  Container,
  Grid,
  Segment,
  Statistic,
  Header,
  Divider,
  Table,
  Button,
  Icon,
  Accordion,
  Modal
} from 'semantic-ui-react';
import { PrivateRoute, SideMenu } from '../../_components';
import {
  useCurrentUser,
  servicesAPI,
  useCustomers,
  useHydras,
  useServiceStatuses
} from '../../_services';
import { copyToClipboard } from '../../utils';
import { ListUsers } from './ListUsers';
import { ListCustomers } from './ListCustomers';
import { ListLances } from './ListLances';
import { ListHUBs } from './ListHUBs';
import { DisplayHUB } from './DisplayHUB';
import { DisplayHUBInterface } from './DisplayHUBInterface';
import { DisplayCS } from './DisplayCS';
import { ListSessions } from './ListSessions';
import { DisplaySession } from './DisplaySession';
import { DisplayWeather } from './DisplayWeather';
import { DisplayMap } from './DisplayMap';
import { DisplayCustomer } from './DisplayCustomer';
import { ChargingSessions } from './ChargingSessions';
import { ListCustomersContracts } from './ListCustomersContracts';
import { ListAlerts } from './ListAlerts';
import { ListAudit } from './ListAudit';
import { ListLocalAuthorities } from './ListLocalAuthorities';
import { ListAONSurveys } from './ListAonSurveys';
import { DisplayAonSurvey } from './DisplayAonSurvey';
import { ListBills } from './ListBills';
import { ListPendingBills } from './ListPendingBills';
import { Overview } from './Overview';
import { BetaFeatures } from './BetaFeatures';
import { UserProfile } from './UserProfile';
import ScrollToTop from '../../_components/layout/ScrollToTop';

const Config = require('../../conf');
const moment = extendMoment(Moment);

const VAPID_PUBLIC_KEY =
  'BINwrJVOMH8RJ5xLek1bF0z8MrhXk3ZKlKP7R6wdZFQTAQ9fB3ZB2bo4TlYdT6KRPkAI7uRP8AjqT2rp7IdNGQ8';

// Global cache
window.hubLocationInfo = null;

export const AdminNotification = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const message = decodeURIComponent(params.get('msg')).split('::')[0];

  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 800 }}>
            <div>
              <Segment>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h4">NOTIFICATION</Header>
                      <p>{message}</p>
                      <br />
                      <Button
                        color="olive"
                        onClick={() => {
                          history.push('/admin');
                        }}
                      >
                        OK
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

const Services = ({
  servicesHide,
  servicesSummary,
  servicesData,
  setServicesHide
}) => (
  <Segment>
    <Divider hidden />
    <Grid>
      <Accordion>
        <Accordion.Title
          active={!servicesHide}
          index={0}
          onClick={() => {
            setServicesHide(!servicesHide);
          }}
        >
          <Header as="h2">
            <Icon name="dropdown" />
            Services ({servicesSummary})
          </Header>
        </Accordion.Title>
        <Accordion.Content active={!servicesHide}>
          <Table
            basic="very"
            selectable
            stackable
            headerRow={['Service', 'Status', 'Last Checked', 'Info']}
            renderBodyRow={({ name, status, timestamp, additional_info }) => ({
              key: name,
              cells: [
                {
                  key: 'name',
                  content: name
                },
                {
                  key: 'status',
                  content:
                    status === 'OK' ? (
                      <p style={{ color: 'green' }}>{status}</p>
                    ) : (
                      <p style={{ color: 'red' }}>{status}</p>
                    )
                },
                {
                  key: 'timestamp',
                  content: timestamp
                },
                {
                  key: 'additional_info',
                  content: additional_info
                }
              ]
            })}
            tableData={servicesData}
          />
        </Accordion.Content>
      </Accordion>
    </Grid>
    <br />
  </Segment>
);

export const AdminDashboard = () => {
  const { currentUser, currentUserCan } = useCurrentUser();

  const [version, setVersion] = useState('unknown');
  const [savedToken, setSavedToken] = useState(false);

  const [numHydras, setNumHydras] = useState(0);
  const [numHUBs, setNumHUBs] = useState(0);
  const [numAONs, setNumAONs] = useState(0);

  const [servicesData, setServicesData] = useState([]);
  const [events, setEvents] = useState([]);
  const [orionTypes, setOrionTypes] = useState([]);
  const [notificationsData, setNotificationsData] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [overrideSubscription, setOverrideSubscription] = useState(false);

  const [servicesSummary, setServicesSummary] = useState('');
  const [servicesHide, setServicesHide] = useState(true);
  const [alertsHide, setAlertsHide] = useState(false);
  const [notificationsHide, setNotificationsHide] = useState(true);
  const [orionTickets, setOrionTickets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFireworks, setShowFireworks] = useState(false);

  const customers = useCustomers();
  const hydras = useHydras();
  const services = useServiceStatuses();

  const dispatch = useDispatch();
  const displaySuccessMessage = message =>
    dispatch(
      setToast({
        title: 'Success',
        body: message
      })
    );

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Clear cache?
  if (params.get('reload')) {
    if (caches) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  }

  const updatePushMessaging = () => {
    if (currentUser && !savedToken) {
      // Already registered?
      if ('serviceWorker' in navigator && 'PushManager' in window) {
        console.log('Service Worker and push messaging are supported');
        navigator.serviceWorker
          .getRegistration('/service_worker.js')
          .then(function(registration) {
            console.log('DEBUG: Registration=' + JSON.stringify(registration));
            if (registration) {
              registration.pushManager
                .getSubscription()
                .then(function(subscription) {
                  console.log(
                    'DEBUG: Subscription=' + JSON.stringify(subscription)
                  );
                  // Already subscribed on a device
                  if (subscription) {
                    if (overrideSubscription) {
                      setPushNotificationToken(subscription);
                      displaySuccessMessage('Updated notification device');
                    }
                    setSavedToken(true);
                  } else {
                    registration.pushManager
                      .subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlB64ToUint8Array(
                          VAPID_PUBLIC_KEY
                        )
                      })
                      .then(function(subscription) {
                        console.log(
                          'DEBUG: Subscription=' + JSON.stringify(subscription)
                        );
                        setPushNotificationToken(subscription);
                        displaySuccessMessage('Updated notification device');
                        setSavedToken(true);
                      });
                  }
                });
            }
          });
      } else {
        alert('Service Worker or push messaging are not supported');
        console.log('Service Worker or push messaging are not supported');
      }
    }
  };

  useEffect(() => {
    servicesAPI
      .AdminServices('getOrionTypes')
      .then(types => setOrionTypes(types));

    const appInfo = localStorage.getItem('appInfo');
    if (appInfo) setVersion(JSON.parse(appInfo).version);

    setShowFireworks(params.get('fireworks') === 'true');
  }, []); // eslint-disable-line

  useEffect(() => {
    setNumHydras(
      hydras.filter(
        h => h.tag_status === 'ACTIVE' && h.reference.startsWith('hyd')
      ).length
    );
    setNumHUBs(
      hydras.filter(
        h => h.tag_status === 'ACTIVE' && h.reference.startsWith('hub')
      ).length
    );
    setNumAONs(
      hydras.filter(
        h => h.tag_status === 'ACTIVE' && h.reference.startsWith('aon')
      ).length
    );
  }, [hydras]); // eslint-disable-line

  useEffect(() => {
    updatePushMessaging();
  }, [overrideSubscription]); // eslint-disable-line

  const setPushNotificationToken = subscription => {
    if (!currentUser) {
      return;
    }

    if (Notification.permission === 'denied') {
      console.log('Notification permission denied');
      subscription = '';
    } else {
      console.log('Notification permission allowed');
      subscription = subscription === null ? '' : subscription;
    }

    const data = {
      push_notification_token: subscription
    };

    servicesAPI
      .CustomerServices('setPushNotificationToken', data, currentUser.id)
      .then(
        response => {},
        error => {}
      );
  };

  const sendNotification = message => {
    if (!currentUser) return;

    const values = {
      message: `${message}::/admin`
    };

    servicesAPI.CustomerServices('notifyUser', currentUser.id, values).then(
      response => {},
      error => {}
    );

    displaySuccessMessage('Sent test notification');
  };

  const closeEvent = eventId => {
    const values = {
      status: 'CLOSED',
      closed_by_user_id: currentUser.id
    };

    servicesAPI.AdminServices('updateEvent', eventId, values).then(
      response => {
        setEventsData(eventsData.filter(e => e.id !== eventId));
      },
      error => {}
    );
  };

  const urlB64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  };

  const loadAlerts = () => {
    servicesAPI
      .AdminServices('getActiveEvents')
      .then(events => setEvents(events));
  };

  const loadNotifications = () => {
    const notifications = JSON.parse(localStorage.getItem('notifications'));

    if (notifications) {
      // console.log(localStorage.getItem('notifications'));
      setNotificationsData(
        notifications.data.map((n, idx) => {
          return {
            idx: idx,
            time: n.time,
            type: n.type,
            message: n.message,
            link: n.link
          };
        })
      );
    }
  };

  const clearNotifications = () => {
    localStorage.setItem('notifications', JSON.stringify({ data: [] }));
    setNotificationsData([]);
  };

  useEffect(() => {
    loadNotifications();
    loadAlerts();

    // Refresh every 10 seconds
    const interval = setInterval(() => {
      const newNotification = localStorage.getItem('newNotification');
      if (newNotification) {
        localStorage.removeItem('newNotification');
        loadAlerts();
        loadNotifications();
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (!showFireworks) return;

    // When animating on canvas, it is best to use requestAnimationFrame instead of setTimeout or setInterval
    // Not supported in all browsers though and sometimes needs a prefix, so we need a shim
    window.requestAnimFrame = (function() {
      return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        function(callback) {
          window.setTimeout(callback, 1000 / 60);
        }
      );
    })();

    var canvas = document.getElementById('canvas'),
      ctx = canvas.getContext('2d'),
      cw = window.innerWidth,
      ch = window.innerHeight,
      fireworks = [],
      particles = [],
      hue = 120, // starting hue
      timerTotal = 20, // launch firework every 20 loop ticks
      timerTick = 0;

    canvas.width = cw;
    canvas.height = ch;

    const random = (min, max) => Math.random() * (max - min) + min;

    const calculateDistance = (p1x, p1y, p2x, p2y) => {
      const xDistance = p1x - p2x;
      const yDistance = p1y - p2y;
      return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
    };

    function Firework(sx, sy, tx, ty) {
      // actual coordinates
      this.x = sx;
      this.y = sy;
      // starting coordinates
      this.sx = sx;
      this.sy = sy;
      // target coordinates
      this.tx = tx;
      this.ty = ty;
      // distance from starting point to target
      this.distanceToTarget = calculateDistance(sx, sy, tx, ty);
      this.distanceTraveled = 0;
      // track the past coordinates of each firework to create a trail effect, increase the coordinate count to create more prominent trails
      this.coordinates = [];
      this.coordinateCount = 3;
      // populate initial coordinate collection with the current coordinates
      while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y]);
      }
      this.angle = Math.atan2(ty - sy, tx - sx);
      this.speed = 2;
      this.acceleration = 1.05;
      this.brightness = random(50, 70);
      // circle target indicator radius
      this.targetRadius = 1;
    }

    Firework.prototype.update = function(index) {
      // remove last item in coordinates array
      this.coordinates.pop();
      // add current coordinates to the start of the array
      this.coordinates.unshift([this.x, this.y]);

      // cycle the circle target indicator radius
      if (this.targetRadius < 8) this.targetRadius += 0.3;
      else this.targetRadius = 1;

      // speed up the firework
      this.speed *= this.acceleration;

      // get the current velocities based on angle and speed
      var vx = Math.cos(this.angle) * this.speed,
        vy = Math.sin(this.angle) * this.speed;
      // how far will the firework have traveled with velocities applied?
      this.distanceTraveled = calculateDistance(
        this.sx,
        this.sy,
        this.x + vx,
        this.y + vy
      );

      // if the distance traveled, including velocities, is greater than the initial distance to the target, then the target has been reached
      if (this.distanceTraveled >= this.distanceToTarget) {
        createParticles(this.tx, this.ty);
        // remove the firework, use the index passed into the update function to determine which to remove
        fireworks.splice(index, 1);
      } else {
        // target not reached, keep traveling
        this.x += vx;
        this.y += vy;
      }
    };

    Firework.prototype.draw = function() {
      ctx.beginPath();
      // move to the last tracked coordinate in the set, then draw a line to the current x and y
      ctx.moveTo(
        this.coordinates[this.coordinates.length - 1][0],
        this.coordinates[this.coordinates.length - 1][1]
      );
      ctx.lineTo(this.x, this.y);
      ctx.strokeStyle = 'hsl(' + hue + ', 100%, ' + this.brightness + '%)';
      ctx.stroke();

      ctx.beginPath();
      // draw the target for this firework with a pulsing circle
      ctx.arc(this.tx, this.ty, this.targetRadius, 0, Math.PI * 2);
      ctx.stroke();
    };

    function Particle(x, y) {
      this.x = x;
      this.y = y;
      // track the past coordinates of each particle to create a trail effect, increase the coordinate count to create more prominent trails
      this.coordinates = [];
      this.coordinateCount = 5;
      while (this.coordinateCount--) {
        this.coordinates.push([this.x, this.y]);
      }
      // set a random angle in all possible directions, in radians
      this.angle = random(0, Math.PI * 2);
      this.speed = random(1, 10);
      // friction will slow the particle down
      this.friction = 0.95;
      // gravity will be applied and pull the particle down
      this.gravity = 1;
      // set the hue to a random number +-20 of the overall hue variable
      this.hue = random(hue - 20, hue + 20);
      this.brightness = random(50, 80);
      this.alpha = 1;
      // set how fast the particle fades out
      this.decay = random(0.015, 0.03);
    }

    Particle.prototype.update = function(index) {
      // remove last item in coordinates array
      this.coordinates.pop();
      // add current coordinates to the start of the array
      this.coordinates.unshift([this.x, this.y]);
      // slow down the particle
      this.speed *= this.friction;
      // apply velocity
      this.x += Math.cos(this.angle) * this.speed;
      this.y += Math.sin(this.angle) * this.speed + this.gravity;
      // fade out the particle
      this.alpha -= this.decay;

      // remove the particle once the alpha is low enough, based on the passed in index
      if (this.alpha <= this.decay) {
        particles.splice(index, 1);
      }
    };

    Particle.prototype.draw = function() {
      ctx.beginPath();
      // move to the last tracked coordinates in the set, then draw a line to the current x and y
      ctx.moveTo(
        this.coordinates[this.coordinates.length - 1][0],
        this.coordinates[this.coordinates.length - 1][1]
      );
      ctx.lineTo(this.x, this.y);
      ctx.strokeStyle =
        'hsla(' +
        this.hue +
        ', 100%, ' +
        this.brightness +
        '%, ' +
        this.alpha +
        ')';
      ctx.stroke();
    };

    // create particle group/explosion
    function createParticles(x, y) {
      // increase the particle count for a bigger explosion, beware of the canvas performance hit with the increased particles though
      var particleCount = 30;
      while (particleCount--) {
        particles.push(new Particle(x, y));
      }
    }

    function loop() {
      // this function will run endlessly with requestAnimationFrame
      window.requestAnimFrame(loop);

      // increase the hue to get different colored fireworks over time
      hue += 0.5;

      // normally, clearRect() would be used to clear the canvas
      // we want to create a trailing effect though
      // setting the composite operation to destination-out will allow us to clear the canvas at a specific opacity, rather than wiping it entirely
      ctx.globalCompositeOperation = 'destination-out';
      // decrease the alpha property to create more prominent trails
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      ctx.fillRect(0, 0, cw, ch);
      // change the composite operation back to our main mode
      // lighter creates bright highlight points as the fireworks and particles overlap each other
      ctx.globalCompositeOperation = 'lighter';

      var i = fireworks.length;
      while (i--) {
        fireworks[i].draw();
        fireworks[i].update(i);
      }

      i = particles.length;
      while (i--) {
        particles[i].draw();
        particles[i].update(i);
      }

      // launch fireworks automatically to random coordinates
      if (timerTick >= timerTotal) {
        // start the firework at the bottom middle of the screen, then set the random target coordinates, the random y coordinates will be set within the range of the top half of the screen
        fireworks.push(
          new Firework(cw / 2, ch, random(0, cw), random(0, ch / 2))
        );
        timerTick = 0;
      } else {
        timerTick++;
      }
    }

    window.onload = loop;
  }, [showFireworks]);

  useEffect(() => {
    if (services.length && !servicesData.length) {
      let summary = 'OK';
      // <p style={{ color: 'green' }}>OK</p>
      // <p style={{ color: 'red' }}>ERROR</p>

      setServicesData(
        services.map(svc => {
          if (svc.status !== 'OK') {
            summary = 'ERROR';
            setServicesHide(false);
          }

          return {
            name: svc.entity_id,
            status: svc.status,
            timestamp: svc.timestamp ? dbUTCDatetimeToLocal(svc.timestamp) : '',
            additional_info: svc.additional_info
          };
        })
      );
      setServicesSummary(summary);
    }
  }, [services]); // eslint-disable-line

  const filterAlert = e => {
    // Experimental alerts visible to Technical team
    if (e.type.startsWith('TEST')) return currentUserCan('DoAllTheThings');

    return true;
  };

  useEffect(() => {
    if (events.length && !eventsData.length) {
      let sortedEvents = events
        .filter(e => filterAlert(e))
        .map(e => {
          // let entityType = '';
          // let entityId = '';
          let area = '';

          // if (['HYDRA', 'PHALANX'].includes(e.entity_type)) {
          //   entityType = e.entity_type;
          //   entityId = e.entity_id;
          // } else {
          //   // Catch all. Search description for Hydra/Phalanx tags
          //   e.description.split(' ').forEach(s => {
          //     const parts = s.split('#');
          //     if (parts.length > 1) {
          //       const linkId = parts[1];
          //       if (linkId.startsWith('HMATG')) {
          //         entityType = 'HYDRA';
          //         entityId = linkId.substring(1);
          //       } else if (linkId.startsWith('PMATG')) {
          //         entityType = 'PHALANX';
          //         entityId = linkId.substring(1);
          //       }
          //     }
          //   });
          // }
          // if (entityType === 'HYDRA') {
          //   const hydraInfo = hydraLocationInfo.find(h => h.tagId === entityId);
          //   area = hydraInfo ? hydraInfo.area : '';
          // } else if (entityType === 'PHALANX') {
          //   hydraLocationInfo.forEach(h => {
          //     const found = h.phalanxTagIds.find(
          //       phalanxTagId => phalanxTagId === entityId
          //     );
          //     if (found) area = h.area;
          //   });
          // }

          return {
            id: e.id,
            area: area,
            entity_type: e.entity_type,
            entity_id: e.entity_id,
            type: e.type,
            status: e.status,
            start_timestamp: e.start_timestamp
              ? dbUTCDatetimeToLocal(e.start_timestamp)
              : '',
            latest_timestamp: e.latest_timestamp
              ? dbUTCDatetimeToLocal(e.latest_timestamp)
              : '',
            description: e.description
          };
        });

      setEventsData(sortedEvents);
    }
  }, [events]); // eslint-disable-line

  const displayOrionTickets = (type, entityType, entityId, description) => {
    const isOrionType = [
      'NOT_RESPONDING',
      'WATER_INGRESS',
      'GENERAL_ERROR'
    ].includes(type);

    if (!isOrionType) return '';

    return (
      <Icon
        link
        circular
        name="file"
        onClick={() => {
          let getType = null;
          if (entityType === 'HYDRA') getType = 'getOrionsByHydra';
          else if (entityType === 'PHALANX') getType = 'getOrionsByPhalanx';
          else if (entityType === 'LANCE') getType = 'getOrionsByLance';
          else if (entityType === 'CUSTOMER') getType = 'getOrionsByCustomer';
          // SERVICE
          // METER
          // CHARGE_PROFILE
          if (!getType) return;

          let orionType = null;
          if (type === 'NOT_RESPONDING') orionType = 'Hydra/CSMS Comms';
          else if (type === 'WATER_INGRESS') orionType = 'Water Ingress';
          else if (type === 'GENERAL_ERROR') {
            if (description.includes('LockFailedState'))
              orionType = 'Lock Mechanism Failure';
            else if (
              description.includes('InitLanceFailed') ||
              description.includes('ManagingMessState')
            )
              orionType = 'Init Lance Failure';
          }
          // TEST_ZERO_READING
          // TEST_READING_LESS_THAN_PREVIOUS
          // TEST_OCCUPIED_WITH_NO_SESSION
          // TEST_OCCUPIED_BUT_NO_LANCE
          // EV_ERROR
          // CHECKING_ACTUAL
          // NOT_CHARGING
          // UPDATING_OCCUPIED
          // STALE_READING
          // WAITING_POLE_DROPPED
          // TOP_SWITCH_OPEN
          // LANCE_STATES_INCONSISTENT
          // ZERO_READING
          // PROBLEM_REPORT
          // CURRENT_OVERDRAW
          // PHALANX_FREE_BUT_HAS_LANCE
          // UNPAID_ACCOUNT
          // EV_BABBLING
          // CHARGING_ERROR
          // LANCE_IN_TWO_PLACES
          // WAITING_LANCE
          // SERVICE_DOWN

          if (!orionType) return;

          servicesAPI.AdminServices(getType, entityId).then(orions => {
            setOrionTickets(
              orions.filter(o => {
                // Ignore old tickets (over 2 days old)
                const diffDays = moment
                  .utc()
                  .diff(
                    moment.utc(o.created_datetime, 'YYYY-MM-DDTHH:mm:ss,Z'),
                    'days'
                  );
                if (diffDays > 2) return false;

                const eventType = orionTypes.event_types.find(
                  t => t.id === o.event_type_id
                );
                if (entityType === 'HYDRA')
                  return eventType?.name === orionType && !o.phalanx_tag_id;
                else return eventType?.name === orionType;
              })
            );
            setIsModalOpen(true);
          });
        }}
      />
    );
  };

  return (
    <React.Fragment>
      <Container>
        <Segment.Group horizontal style={{ marginTop: 0 }}>
          <Segment>
            <Statistic>
              <Statistic.Value>
                {
                  customers.filter(
                    c => c.status === 'Active' && !c.test_account
                  ).length
                }
              </Statistic.Value>
              <Statistic.Label>Customers</Statistic.Label>
            </Statistic>
          </Segment>
          <Segment>
            <Statistic>
              <Statistic.Value>{numHydras}</Statistic.Value>
              <Statistic.Label>Hydras</Statistic.Label>
            </Statistic>
          </Segment>
          <Segment>
            <Statistic>
              <Statistic.Value>{numHUBs}</Statistic.Value>
              <Statistic.Label>HUBs</Statistic.Label>
            </Statistic>
          </Segment>
          <Segment>
            <Statistic>
              <Statistic.Value>{numAONs}</Statistic.Value>
              <Statistic.Label>HOMEs</Statistic.Label>
            </Statistic>
          </Segment>
        </Segment.Group>
        {servicesSummary === 'ERROR' && (
          <Services
            servicesHide={servicesHide}
            servicesSummary={servicesSummary}
            servicesData={servicesData}
            setServicesHide={setServicesHide}
          />
        )}
        <Segment>
          {' '}
          <Button
            color="olive"
            onClick={() => {
              document.location.href = '/admin/overview';
            }}
          >
            HUB Overview
          </Button>
          <br />
        </Segment>
        <Segment>
          <Divider hidden />
          <Grid>
            <Accordion>
              <Accordion.Title
                active={!alertsHide}
                index={0}
                onClick={() => {
                  setAlertsHide(!alertsHide);
                }}
              >
                <Header as="h2">
                  <Icon name="dropdown" />
                  Alerts ({eventsData.length})
                </Header>
              </Accordion.Title>
              <Accordion.Content active={!alertsHide}>
                <Table
                  basic="very"
                  selectable
                  stackable
                  headerRow={[
                    'ID',
                    'First',
                    'Latest',
                    'Description',
                    'Orion',
                    'Close'
                  ]}
                  renderBodyRow={({
                    id,
                    entity_type,
                    entity_id,
                    type,
                    start_timestamp,
                    latest_timestamp,
                    description
                  }) => ({
                    key: id,
                    cells: [
                      {
                        key: 'id',
                        content: id
                      },
                      {
                        key: 'start_timestamp',
                        content: start_timestamp
                      },
                      {
                        key: 'latest_timestamp',
                        content: latest_timestamp
                      },
                      {
                        key: 'description',
                        content: linkifyText(description),
                        onClick: () => {
                          copyToClipboard(deLinkifyText(description));
                        }
                      },
                      {
                        key: 'orion',
                        content: displayOrionTickets(
                          type,
                          entity_type,
                          entity_id,
                          description
                        )
                      },
                      {
                        key: 'close',
                        content: (
                          <Icon
                            link
                            circular
                            name="edit"
                            onClick={() => {
                              closeEvent(id);
                            }}
                          />
                        )
                      }
                    ]
                  })}
                  tableData={eventsData}
                />
              </Accordion.Content>
            </Accordion>
          </Grid>
          <br />
        </Segment>
        <ChargingSessions />
        <Segment>
          <Divider hidden />
          <Grid>
            <Accordion>
              <Accordion.Title
                active={!notificationsHide}
                index={0}
                onClick={() => {
                  setNotificationsHide(!notificationsHide);
                }}
              >
                <Header as="h2">
                  <Icon name="dropdown" />
                  Notifications ({notificationsData.length})
                </Header>
              </Accordion.Title>
              <Accordion.Content active={!notificationsHide}>
                <Table
                  basic="very"
                  selectable
                  stackable
                  headerRow={['Time', 'Message', 'Dismiss']}
                  renderBodyRow={({ idx, time, type, message, link }) => ({
                    key: idx,
                    cells: [
                      {
                        key: 'time',
                        content: time
                      },
                      {
                        key: 'message',
                        content: message
                      },
                      {
                        key: 'dismiss',
                        content: (
                          <Icon
                            link
                            circular
                            name="edit"
                            onClick={() => {
                              const notifications = JSON.parse(
                                localStorage.getItem('notifications')
                              );
                              notifications.data.splice(idx, 1);
                              localStorage.setItem(
                                'notifications',
                                JSON.stringify(notifications)
                              );
                              loadNotifications();
                            }}
                          />
                        )
                      }
                    ]
                  })}
                  tableData={notificationsData}
                />
                <br />
                <Button
                  color="olive"
                  onClick={() => {
                    clearNotifications();
                  }}
                >
                  Dismiss all notifications
                </Button>
                <Button
                  color="olive"
                  onClick={() => {
                    setOverrideSubscription(true);
                  }}
                >
                  Send notifications to this device
                </Button>
                <Button
                  color="olive"
                  onClick={() => {
                    sendNotification('This is a test notification');
                  }}
                >
                  Send a test notification
                </Button>
              </Accordion.Content>
            </Accordion>
          </Grid>
          <br />
        </Segment>
        {servicesSummary === 'OK' && (
          <Services
            servicesHide={servicesHide}
            servicesSummary={servicesSummary}
            servicesData={servicesData}
            setServicesHide={setServicesHide}
          />
        )}
        <Segment>
          <p>Portal version: {version}</p>
        </Segment>
        <Modal open={isModalOpen} size="small" style={{ padding: '20px' }}>
          <Modal.Content>
            <Header as="h2" textAlign="left">
              Orion Tickets
            </Header>
            {orionTickets.length ? (
              orionTickets.map(orionTicket => (
                <>
                  <a
                    href={`${Config.Local().orion_url}/orion/ticket/${
                      orionTicket.id
                    }`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {orionTicket.ticket_number}
                  </a>
                  <br />
                </>
              ))
            ) : (
              <>
                No associated ticket found.{' '}
                <a
                  href={`${Config.Local().orion_url}/orion/tickets/create`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Create one?
                </a>
                <br />
              </>
            )}
            <br />
            <Button basic color="olive" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
          </Modal.Content>
        </Modal>
      </Container>
      <div style={{ margin: 0, position: 'absolute' }}>
        <canvas id="canvas"></canvas>
      </div>
    </React.Fragment>
  );
};

const AdminRoutes = ({ currentUserCan }) => {
  return (
    <Grid stackable style={{ flexWrap: 'nowrap' }}>
      <Grid.Column stretched width={16}>
        <Router history={history}>
          <ScrollToTop />
          <Switch>
            <PrivateRoute
              exact
              path="/admin"
              roles={[
                'Admin',
                'CustomerSupport',
                'Support',
                'Executive',
                'Monitor'
              ]}
              component={AdminDashboard}
            />
            <PrivateRoute
              exact
              path="/admin/overview"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={Overview}
            />
            <PrivateRoute
              exact
              path="/admin/users"
              roles={['Admin', 'Executive']}
              component={ListUsers}
            />
            <PrivateRoute
              exact
              path="/admin/lances"
              roles={['Admin', 'CustomerSupport', 'Support']}
              component={ListLances}
            />
            <PrivateRoute
              exact
              path="/admin/hubs"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={ListHUBs}
            />
            <PrivateRoute
              exact
              path="/admin/billing"
              roles={['Admin', 'Support']}
              component={ListBills}
            />
            <PrivateRoute
              exact
              path="/admin/pending-bills"
              roles={['Admin', 'Support', 'CustomerSupport']}
              component={ListPendingBills}
            />
            <PrivateRoute
              exact
              path="/admin/aon/postcodes"
              roles={['Admin', 'Support', 'Executive']}
              component={ListLocalAuthorities}
            />
            <PrivateRoute
              exact
              path="/admin/aon/surveys"
              roles={['Admin', 'Support', 'Executive']}
              // authorised={currentUserCan('ManageAON')}
              component={ListAONSurveys}
            />
            <PrivateRoute
              exact
              path="/admin/aon/survey/:id"
              roles={['Admin', 'Support', 'Executive']}
              // authorised={currentUserCan('ManageAON')}
              component={DisplayAonSurvey}
            />
            <PrivateRoute
              exact
              path="/admin/weather"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayWeather}
            />
            <PrivateRoute
              exact
              path="/admin/map"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayMap}
            />
            <PrivateRoute
              exact
              path="/admin/hubs/:hub_ref"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayHUB}
            />
            <PrivateRoute
              exact
              path="/admin/hubs/:hydra_ref/:cs_id/sessions"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={ListSessions}
            />
            <PrivateRoute
              exact
              path="/admin/hubs/:hydra_ref/hub_if"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayHUBInterface}
            />
            <PrivateRoute
              exact
              path="/admin/hubs/:hydra_ref/:cs_id"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayCS}
            />
            <PrivateRoute
              exact
              path="/admin/session/:session_id"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplaySession}
            />
            <PrivateRoute
              exact
              path="/admin/customer/:id"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={DisplayCustomer}
            />
            <PrivateRoute
              exact
              path="/admin/customers"
              roles={['Admin', 'CustomerSupport', 'Support', 'Executive']}
              component={ListCustomers}
            />
            <PrivateRoute
              exact
              path="/admin/customers/contracts"
              roles={['Admin', 'Executive']}
              component={ListCustomersContracts}
            />
            <PrivateRoute
              exact
              path="/admin/user/:_id"
              roles={['Admin', 'Support']}
              component={UserProfile}
            />
            <PrivateRoute
              exact
              path="/admin/alerts"
              roles={['Admin', 'CustomerSupport', 'Support']}
              component={ListAlerts}
            />
            <PrivateRoute
              exact
              path="/admin/audit"
              roles={['Admin']}
              component={ListAudit}
            />
            <PrivateRoute
              exact
              path="/admin/beta"
              roles={['Admin']}
              component={BetaFeatures}
            />
            <PrivateRoute
              exact
              path="/admin/profile"
              roles={['Admin']}
              component={UserProfile}
            />
          </Switch>
        </Router>
      </Grid.Column>
    </Grid>
  );
};

export const AdminPage = () => {
  const { currentUserCan } = useCurrentUser();

  const enableSideMenu = currentUserCan('BetaTest');

  // Can't override body style via CSS, hence:
  document.body.style.flexDirection = 'row';

  return (
    <div>
      <div
        style={{ backgroundImage: "url('/images/background.jpg')" }}
        className="bgimage-admin fade-in"
      />
      <Container
        style={{ marginTop: '50px', marginBottom: '60px', minHeight: '660px' }}
      >
        {enableSideMenu ? (
          <Sidenav.Layout sidenav={<SideMenu />}>
            <AdminRoutes currentUserCan={currentUserCan} />
          </Sidenav.Layout>
        ) : (
          <AdminRoutes currentUserCan={currentUserCan} />
        )}
      </Container>
    </div>
  );
};
